import {i18n} from '@yourcoach/i18n';

export interface SubgoalType {
  id: string;
  toString: () => string;
}

export interface SubgoalTypeEnumT {
  CHECKLIST: SubgoalType;
  METRIC: SubgoalType;
}

export const SubgoalTypeEnum: SubgoalTypeEnumT = {
  CHECKLIST: {
    id: 'checklist',
  },
  METRIC: {
    id: 'metric',
  },
};

Object.keys(SubgoalTypeEnum).forEach(key => {
  const type: SubgoalType = SubgoalTypeEnum[key];

  type.toString = () =>
    /**
     * @i18n_parser
     * t('shared:goal.subgoal.type.checklist')
     * t('shared:goal.subgoal.type.metric')
     */
    i18n.t(`shared:goal.subgoal.type.${type.id}`);
});

export const getSubgoalUnitTypes = () =>
  (i18n.t('shared:goal.subgoal.units') || '').split(',');
